import React from 'react';
import {createRoot} from 'react-dom/client';
import CustomerJourney from "./Journeys/CustomerJourney";

const SaveMoreMoneyIsa = (props) => {
    const renderJourney = () => {
        return <CustomerJourney />
    }

    return renderJourney();
}

export default SaveMoreMoneyIsa;

const targetNode = document.getElementById('savemoremoney-application');
if (targetNode) {
    const root = createRoot(targetNode);
    const dataset = targetNode.dataset;

    root.render(
        <SaveMoreMoneyIsa />
    );
}
